<div class="min-h-[calc(100vh-10rem)] flex items-center justify-center py-12 px-4">
  <div class="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl border border-gray-200">
    <div class="text-center">
      <h1 class="text-2xl font-bold text-gray-900">Reset password</h1>
      <p class="mt-1 text-sm text-gray-600">Choose a new password for your account.</p>
    </div>

    @if (token) {
      <app-password-form
        [showCurrentPassword]="false"
        [loading]="loading"
        [error]="error"
        submitLabel="Reset password"
        loadingLabel="Resetting..."
        cancelLabel="Back to login"
        (passwordSubmit)="resetPassword($event)"
        (canceled)="goToLogin()"
      ></app-password-form>
    } @else {
      <div class="mt-6 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
        {{ error }}
      </div>

      <div class="mt-4 flex justify-center">
        <button
          type="button"
          (click)="goToLogin()"
          class="rounded-lg bg-secondary px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-hover"
        >
          Back to login
        </button>
      </div>
    }
  </div>
</div>
